export enum DaysToHours {
  twoDays = 48,
  week = 168,
  month = 672,
}
